import { render, staticRenderFns } from "./ProductPage5.vue?vue&type=template&id=d0dc4f24"
import script from "./ProductPage5.vue?vue&type=script&lang=js"
export * from "./ProductPage5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports